export default "__VITE_ASSET__D92Dd2Ol__"